import { GitBlameLine } from '../models/git-worker.model';
import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitBlameAction extends WorkerAction {
  type: GitAction.Blame;
  params: { path: string; commitSha?: string; contents?: string };
}

export class GitBlameActionError extends WorkerActionError {}

export async function GitBlameActionFn(params: WorkerFnParams<GitBlameAction>): Promise<GitBlameLine[]> {
  try {
    const {
      lg,
      params: { path, commitSha, contents },
    } = params;

    const blameOutput = lg.callAndCaptureOutput([
      'blame',
      ...(commitSha ? [commitSha] : []),
      path,
      ...(contents ? ['--', '--contents', contents.replace(/"/g, '"')] : []),
    ]);
    const blameLines: GitBlameLine[] = [];
    loopThroughLines(blameOutput, (line) => {
      const blameLine = parseBlameLine(line);
      blameLines.push(blameLine);
    });

    return blameLines;
  } catch (err) {
    throw new GitBlameActionError(err);
  }
}

function loopThroughLines(text: string, callback: (line: string) => void) {
  let start = 0;
  let end = 0;
  while ((end = text.indexOf('\n', start)) !== -1) {
    const line = text.substring(start, end);
    callback(line);
    start = end + 1;
  }
  const finalLine = text.substring(start);
  callback(finalLine);
}

// a23dfc4de ( author <author@email.com>      1) {
const blameLineRe = /(.+) \( (.+?) (<.+>)\s+(.+?)\) (.*)/;

function parseBlameLine(line: string): GitBlameLine {
  const res = blameLineRe.exec(line)!;
  const sha = res[1] ?? '';
  const author = res[2] ?? '';
  const email = res[3] ?? '';
  const lineNumber = Number(res[4] ?? -1);
  const text = res[5] ?? '';
  return {
    sha,
    author,
    email,
    lineNumber,
    text,
  };
}
